<template lang="html">
    <div class="common-select common-select-datetime">
        <input type="hidden" v-bind:value="innerValue" />
        <div class="common-select-title"><span @click="handleSelectClick">{{title}}</span><common-tooltip v-if="!!tipCode" :tipCode="tipCode"></common-tooltip><span class="not-required" :class="required?'required':''">*</span></div>
        <div :class="['common-select-infos',alignRight?'common-select-infos-align-right':'']" @click="handleSelectClick">
            <div class="common-select-text">{{currentText}}</div>
            <div class="common-select-placeholder" v-show="!currentText">{{placeholder}}</div>
            <div v-if="iconType" :class="'common-select-dropdown-icon-'+iconType"></div>
            <div v-else><i class="iconfont icon-rili"></i></div>
        </div>
        <mt-datetime-picker
            :class="[value?'':'hideCancel',disabledDate?'disabledConfirm':'']"
            ref="picker"
            type="date"
            v-model="selectDate"
            :startDate="startDate"
            cancelText="清除"
            @confirm="handleComfirmClick"
            @cancel="handleCancleClick">
        </mt-datetime-picker>
    </div>
</template>

<script>
import { Popup, DatetimePicker  } from 'mint-ui';
  export default {
    props: {
        'title': {
            type: String,
            required: false
        },
        'placeholder': {
            type: String,
            required: false
        },
        'alignRight': {
            type:Boolean,
            required: false,
            default:false,
        },
        'value': {

        },
        'clearable': {
            type:Boolean,
            required: false,
            default:false,
        },
        'defaultDate': {
            required: false,
        },
        'minDate': {
            required: false,
        },
        'required': {
            type:Boolean,
            required: false,
            default: false,
        },
        'tipCode': {
            required: false
        },
        'iconType': {
            type: String,
            required: false,
            default:''
        },
        'pickerOptions': {
            type: Object,
            required: false            
        }
    },
    event: 'change',
    components: {
        Popup,
        DatetimePicker,
    },
    data() {
        return {
            selectDate: null,
        };
    },
    computed: {
        currentText() {
            return  this.innerValue;
        },
        innerValue: {
            get() {
               return this.value 
            },
            set(val) {
                 this.$emit('input', val) //这里多用于子组件间没有input元素中,通过在computed属性中监听值变化事emit input事件
            }
        },
        startDate() {
            let defaultStartDate = new Date(new Date().getFullYear() - 10, 0, 1);
            return this.minDate?this.minDate:defaultStartDate;
        },
        disabledDate() {
            if(this.pickerOptions && this.pickerOptions.disabledDate) {
                return this.pickerOptions.disabledDate(this.selectDate)
            }

            return false;
        }
    },
    methods: {
        handleSelectClick() {
            this.selectDate = this.value?this.value:this.minDate;
            this.$refs.picker.open();
        },
        handleCancleClick() {
            this.innerValue = '';
            this.selectDate = this.defaultDate;
            this.$emit('change');
        },
        handleComfirmClick() {
            if(this.disabledDate) {
                return;
            }

            this.innerValue = moment(this.selectDate).format('YYYY-MM-DD');
            this.$emit('change');
        }
    },
  };
</script>

<style lang="less" scoped>
    .common-select {
        display: flex;
        min-height: 24px;
        font-size: 14px;

        &-title {
            line-height: 24px;
        }

        &-dropdown-icon-trigle {
            width: 0;
            height: 0;
            border-left: 6px solid transparent; //左边宽度50px，实线，透明颜色
            border-right: 6px solid transparent; //右边同上
            border-top: 6px solid #999999;
            margin-top: 9px;
            margin-left: 7px;
        }

        &-dropdown-icon-arrow {
            width: 9px;
            height: 9px;
            margin-top: 7px;
            border-top: 1px solid #999999;
            border-right: 1px solid #999999;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            margin-left: 4px;
        }

        .iconfont {
            line-height: 24px;
            margin-left: 4px;
            margin-right: -5px;
            color: #999999;
        }

        &-text {
            min-height: 24px;
            line-height: 24px;
            max-width: 200px;
        }

        &-infos {
            display: flex;

            &-align-right {
                    margin-left: auto;
                    padding-right: 20px;
            }
        }

        &-placeholder {
            color: #999999;
            line-height: 24px;
        }

        &-options {
            &-toolbar {
                padding: 5px 15px 0 15px;

                &-cancel-btn {
                    float: left;
                }

                &-confirm-btn {
                    float: right;
                }
            }
        }     

        .not-required {
            display: none;
        }
        
        .required {
            display: inline;
            color: #E64100;
            margin-left: 5px;
        }
    }
</style>


// WEBPACK FOOTER //
// CommonSelectDateTime.vue?50674080